// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { configureInternalNavigationFromCMSUrl } from '@tcp/core/src/utils/utils';
import styles from '../styles/MyRewards.style';
import DetailedCouponTile from '../../../molecule/DetailedCouponTile';
import EmptyRewards from '../../../molecule/EmptyRewards';
import EmptyWalletRewards from '../../../molecule/EmptyWalletRewards';
import { COUPON_STATUS } from '../../../../../../../services/abstractors/CnC/CartItemTile';
import MyRewardsSkeleton from '../skeleton/MyRewardsSkeleton.view';
import CouponAndPromos from '../../../../../CnC/common/organism/CouponAndPromos';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import MyRewardsLabels, { CHECKOUT_LABELS, GLOBAL_PLACE_REWARDS } from './MyRewards.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblProgramDetails,
  lblTnc,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const MyRewards = ({
  commonLabels,
  className,
  coupons,
  onViewCouponDetails,
  onApplyCouponToBagFromList,
  onRemove,
  isApplyingOrRemovingCoupon,
  handleErrorCoupon,
  isMobile,
  view,
  showLink,
  isFetching,
  isMPRAndCSHCouponRedesignEnabled,
  couponSelfHelp,
  couponsList,
}) => {
  const placeRewardsLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_PLACE_REWARDS,
    MyRewardsLabels
  );
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, MyRewardsLabels);
  const heading =
    view === 'all'
      ? `${getDynamicLabelValues('dynamic.global_d.lbl_my_rewards_wallet_heading')} (${
          coupons.size
        })`
      : `${getDynamicLabelValues('dynamic.global_d.lbl_my_rewards_heading')} (${coupons.size})`;
  const newHeading = `${renderLabel(
    checkoutLabels?.bagPage?.lbl_reward_and_coupon_title,
    'lbl_reward_and_coupon_title'
  )} (${couponsList?.size})`;
  const isApplyingCoupon = !!coupons.find(
    (coupon) => coupon.status === COUPON_STATUS.APPLYING || coupon.status === COUPON_STATUS.REMOVING
  );

  return (
    <div className={className}>
      <div className="my-reward-styling ">
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              large: 12,
              medium: 8,
            }}
            ignoreGutter={{
              small: true,
              medium: true,
              large: true,
            }}
          >
            <BodyCopy
              fontFamily="secondary"
              fontSize={isMPRAndCSHCouponRedesignEnabled ? 'fs18' : 'fs16'}
              fontWeight="bold"
              className="my-rewards-heading"
              data-locator="my-rewards-heading"
            >
              {isMPRAndCSHCouponRedesignEnabled ? newHeading : heading}
            </BodyCopy>
          </Col>
          <Col
            colSize={{
              small: 6,
              large: 12,
              medium: 8,
            }}
            ignoreGutter={{
              small: true,
              medium: true,
              large: true,
            }}
          >
            {isFetching && <MyRewardsSkeleton />}
            {isMPRAndCSHCouponRedesignEnabled &&
              (couponsList?.size > 0 ? (
                <CouponAndPromos
                  fullPageInfo={true}
                  additionalClassNameModal="coupon-modal-web"
                  idPrefix="desktop"
                  isCheckoutFlow={false}
                  isWallet
                  isCarouselView
                  isAccountDashboard={true}
                  variation={'smooth-carousel'}
                  couponSelfHelp={couponSelfHelp}
                  isFromMPRPage={!couponSelfHelp}
                />
              ) : (
                <EmptyWalletRewards placeRewardsLabels={placeRewardsLabels} />
              ))}
            {!isFetching &&
              !isMPRAndCSHCouponRedesignEnabled &&
              (coupons.size > 0 ? (
                <BodyCopy component="div" className="rewards-container elem-mb-XXL">
                  {coupons.map((coupon, index) => {
                    return (
                      <DetailedCouponTile
                        key={coupon.id}
                        index={index}
                        labels={commonLabels}
                        coupon={coupon}
                        onViewCouponDetails={onViewCouponDetails}
                        onApplyCouponToBagFromList={onApplyCouponToBagFromList}
                        onRemove={onRemove}
                        handleErrorCoupon={handleErrorCoupon}
                        isDisabled={isApplyingOrRemovingCoupon || isApplyingCoupon}
                        isMobile={isMobile}
                        view={view}
                        className="elem-mb-LRG"
                      />
                    );
                  })}
                </BodyCopy>
              ) : (
                <>
                  {view === 'all' ? (
                    <EmptyWalletRewards placeRewardsLabels={placeRewardsLabels} />
                  ) : (
                    <EmptyRewards placeRewardsLabels={placeRewardsLabels} />
                  )}
                </>
              ))}
          </Col>
          {showLink && (
            <>
              <Col
                colSize={{
                  small: 3,
                  large: 6,
                  medium: 4,
                }}
                className="textRight"
              >
                <Anchor
                  fontSizeVariation="medium"
                  underline
                  url={getDynamicLabelValues('dynamic.account_d.lbl_rewardprogram_link')}
                  anchorVariation="primary"
                  dataLocator="my-rewards-program-details"
                  className="elem-mr-SM"
                  target="_blank"
                >
                  {renderLabel(
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_GENERIC_LABELS}.${lblProgramDetails}`,
                      GlobalGenericLabels
                    ),
                    'lbl_program_details'
                  )}
                </Anchor>
              </Col>
              <Col
                colSize={{
                  small: 3,
                  large: 6,
                  medium: 4,
                }}
              >
                <Anchor
                  fontSizeVariation="medium"
                  underline
                  to={configureInternalNavigationFromCMSUrl(
                    getDynamicLabelValues('dynamic.account_d.lbl_termcondition_link')
                  )}
                  asPath={getDynamicLabelValues('dynamic.account_d.lbl_termcondition_link')}
                  anchorVariation="primary"
                  dataLocator="my-rewards-tnc"
                  className="elem-ml-SM"
                  target="_blank"
                >
                  {renderLabel(
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_GENERIC_LABELS}.${lblTnc}`,
                      GlobalGenericLabels
                    ),
                    'lbl_tnc'
                  )}
                </Anchor>
              </Col>
            </>
          )}
        </Row>
      </div>
    </div>
  );
};

MyRewards.propTypes = {
  labels: PropTypes.shape({ common: {}, placeRewardsLabels: {} }),
  commonLabels: PropTypes.shape({}),
  className: PropTypes.string,
  coupons: PropTypes.shape([]),
  onViewCouponDetails: PropTypes.func,
  onRemove: PropTypes.func,
  onApplyCouponToBagFromList: PropTypes.func,
  handleErrorCoupon: PropTypes.func,
  isApplyingOrRemovingCoupon: PropTypes.bool,
  isMobile: PropTypes.bool,
  view: PropTypes.string,
  showLink: PropTypes.bool,
  isFetching: PropTypes.bool,
};

MyRewards.defaultProps = {
  labels: {
    placeRewardsLabels: {
      // lbl_my_rewards_program_details: '',
      // lbl_my_rewards_shop_now: '',
      ACC_LBL_MY_REWARDS_NO_REWARDS_MSG: '',
      ACC_LBL_MY_REWARDS_HEADING: '',
      // lbl_common_tnc: '',
    },
  },
  commonLabels: {},
  className: '',
  coupons: [],
  onViewCouponDetails: () => {},
  onRemove: () => {},
  onApplyCouponToBagFromList: () => {},
  handleErrorCoupon: () => {},
  isApplyingOrRemovingCoupon: false,
  isMobile: true,
  view: '',
  showLink: false,
  isFetching: false,
};

export default withStyles(MyRewards, styles);
export { MyRewards as MyRewardsVanilla };
